
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class CertificationIssueBOMGrid extends Serenity.EntityGrid<CertificationIssueBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.CertificationIssueBOM'; }
        protected getDialogType() { return CertificationIssueBOMDialog; }
        protected getIdProperty() { return CertificationIssueBOMRow.idProperty; }
        protected getInsertPermission() { return CertificationIssueBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return CertificationIssueBOMRow.localTextPrefix; }
        protected getService() { return CertificationIssueBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}